module.exports = __webpack_public_path__ + "img/2.b7d52d84.png";